/**
 * dcent-menu-anchor-dismiss.js — 메뉴 안의 "같은 페이지 앵커" 링크를 누르면 그 메뉴를 닫는다 (MAGE-527).
 *
 * 증상
 *   홈에서 상단 제품 탭을 펼쳐 "제품 비교하기"를 누르면 비교표 위치로 스크롤은 되는데
 *   메가 패널이 그대로 열려 있어 방금 이동한 자리를 가린다.
 *   dev 실측(2026-08-28, 한국 dev 홈 1440): 클릭 직후 scrollY 0 → 3600 인데
 *   `.m-mega-menu` 의 opacity 1 · visibility visible 유지, `:hover` 판정도 true.
 *
 * 원인
 *   패널 펼침이 CSS 의 `.dcent-product-menu-item:hover / :focus-within` 뿐이다(벤더 JS 비의존).
 *   목적지가 같은 문서 안 해시(`/#dcent-store-compare`)라 페이지가 다시 그려지지 않고,
 *   포인터는 클릭한 자리(헤더 위)에 그대로 있어 `:hover` 가 계속 참이다 →
 *   마우스를 딴 데로 옮기기 전까지 패널이 안 닫힌다.
 *
 * 고치는 법
 *   같은 문서 해시 이동일 때만 그 패널을 인라인 스타일로 접고, **포인터가 그 항목을 벗어나면**
 *   인라인 스타일을 지워 원래의 hover 동작으로 돌려놓는다.
 *   - CSS 파일을 건드리지 않는 이유: 펼침 규칙이 `dcent-header.css` 에 있는데 그 파일은
 *     다른 작업과 겹친다. 인라인 스타일은 특이도가 가장 높아 규칙을 그대로 두고 이길 수 있다.
 *   - 다른 페이지로 가는 링크는 대상이 아니다 — 어차피 문서가 새로 그려진다.
 *   - 모바일 드로어(`#m-menu-drawer`)도 같은 이유로 열린 채 남으므로 함께 닫는다.
 *     클래스를 손으로 벗기지 않고 **햄버거를 프로그램적으로 클릭**한다 —
 *     벤더 closeMenu() 가 서브메뉴 클래스·`prevent-scroll` 까지 한 벌로 정리한다
 *     (dcent-menu-viewport-reset.js 와 같은 처방).
 *
 * 양 샵 byte-identical 미러(파리티 게이트 대상).
 */
(function () {
  function normalizePath(p) {
    // '/ja' 와 '/ja/' 를 같은 문서로 본다 — 로케일 프리픽스가 붙는 링크가 있다.
    return p.length > 1 && p.charAt(p.length - 1) === "/" ? p.slice(0, -1) : p;
  }

  function isSameDocumentHash(link) {
    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return false;
    }
    if (!url.hash) return false;
    if (url.origin !== window.location.origin) return false;
    if (normalizePath(url.pathname) !== normalizePath(window.location.pathname)) return false;
    return url.search === window.location.search;
  }

  function collapse(item) {
    var panel = item && item.querySelector(".m-mega-menu");
    if (!panel) return;
    panel.style.opacity = "0";
    panel.style.visibility = "hidden";
    panel.style.pointerEvents = "none";
    if (document.activeElement && item.contains(document.activeElement)) {
      document.activeElement.blur();
    }
    var restore = function () {
      panel.style.opacity = "";
      panel.style.visibility = "";
      panel.style.pointerEvents = "";
      item.removeEventListener("mouseleave", restore);
    };
    item.addEventListener("mouseleave", restore);
  }

  function closeMobileDrawer() {
    var drawer = document.getElementById("m-menu-drawer");
    if (!drawer || !drawer.classList.contains("open")) return;
    var button = document.querySelector(".m-menu-button");
    if (button) button.click(); // 벤더 Megamenu.closeMenu() 경로
  }

  document.addEventListener("click", function (event) {
    var link = event.target && event.target.closest && event.target.closest("a[href]");
    if (!link) return;
    if (!link.closest(".m-header")) return;
    if (!isSameDocumentHash(link)) return;
    collapse(link.closest(".m-menu__item"));
    closeMobileDrawer();
  });
})();
